import React, { useState } from 'react'
import { Layout, Menu } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { siderItems, itemRoutes, getOpenKeys, findKeyForRoute } from './menuConfig'

const { Sider } = Layout

function AdminSider() {
  const navigate = useNavigate()
  const location = useLocation()
  const [openKeys, setOpenKeys] = useState(() => getOpenKeys(findKeyForRoute(location.pathname)))

  return (
    <Sider
      width={220}
      style={{
        background: '#111111',
        borderRight: '1px solid rgba(255,255,255,0.1)',
        position: 'sticky',
        top: 52,
        height: 'calc(100vh - 52px)',
        overflow: 'auto'
      }}
    >
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={findKeyForRoute(location.pathname) ? [findKeyForRoute(location.pathname)] : []}
        openKeys={openKeys}
        onOpenChange={(keys) => setOpenKeys(keys)}
        items={siderItems}
        onClick={({ key }) => {
          if (itemRoutes[key]) navigate(itemRoutes[key])
        }}
        style={{ background: 'transparent', borderRight: 'none', padding: '8px 0' }}
      />
    </Sider>
  )
}

export default AdminSider
